(() => {
  const root = document.documentElement;
  root.classList.add('dn-js');

  const ready = () => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const revealItems = document.querySelectorAll('[data-dn-reveal]');
    if (reduceMotion || !('IntersectionObserver' in window)) {
      revealItems.forEach((item) => item.classList.add('is-visible'));
    } else {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
      revealItems.forEach((item) => observer.observe(item));
    }

    const countdowns = document.querySelectorAll('[data-dn-countdown]');
    countdowns.forEach((countdown) => {
      const targetValue = countdown.dataset.dnCountdown;
      const message = countdown.querySelector('[data-countdown-message]');
      const fields = {
        days: countdown.querySelector('[data-days]'),
        hours: countdown.querySelector('[data-hours]'),
        minutes: countdown.querySelector('[data-minutes]'),
        seconds: countdown.querySelector('[data-seconds]')
      };

      if (!targetValue || Number.isNaN(new Date(targetValue).getTime())) {
        countdown.classList.add('is-undated');
        if (message) message.textContent = countdown.dataset.emptyLabel || 'Release time will be transmitted soon.';
        return;
      }

      const target = new Date(targetValue).getTime();
      const render = () => {
        const remaining = Math.max(0, target - Date.now());
        const days = Math.floor(remaining / 86400000);
        const hours = Math.floor((remaining % 86400000) / 3600000);
        const minutes = Math.floor((remaining % 3600000) / 60000);
        const seconds = Math.floor((remaining % 60000) / 1000);
        fields.days.textContent = String(days).padStart(2, '0');
        fields.hours.textContent = String(hours).padStart(2, '0');
        fields.minutes.textContent = String(minutes).padStart(2, '0');
        fields.seconds.textContent = String(seconds).padStart(2, '0');
        if (remaining === 0) {
          countdown.classList.add('is-live');
          if (message) message.textContent = 'The pursuit is live.';
        } else if (message) {
          message.textContent = 'Until the next DuffNall transmission.';
        }
      };
      render();
      const timer = window.setInterval(render, 1000);
      document.addEventListener('shopify:section:unload', () => window.clearInterval(timer), { once: true });
    });

    if (!reduceMotion && window.matchMedia('(pointer: fine)').matches) {
      document.querySelectorAll('[data-dn-parallax]').forEach((item) => {
        item.addEventListener('pointermove', (event) => {
          const rect = item.getBoundingClientRect();
          const x = ((event.clientX - rect.left) / rect.width - 0.5) * 2;
          const y = ((event.clientY - rect.top) / rect.height - 0.5) * 2;
          item.style.setProperty('--dn-px', x.toFixed(3));
          item.style.setProperty('--dn-py', y.toFixed(3));
        });
        item.addEventListener('pointerleave', () => {
          item.style.setProperty('--dn-px', 0);
          item.style.setProperty('--dn-py', 0);
        });
      });

      document.querySelectorAll('[data-dn-magnetic]').forEach((item) => {
        item.addEventListener('pointermove', (event) => {
          const rect = item.getBoundingClientRect();
          item.style.setProperty('--dn-mx', `${(event.clientX - rect.left - rect.width / 2) * 0.12}px`);
          item.style.setProperty('--dn-my', `${(event.clientY - rect.top - rect.height / 2) * 0.12}px`);
        });
        item.addEventListener('pointerleave', () => {
          item.style.setProperty('--dn-mx', '0px');
          item.style.setProperty('--dn-my', '0px');
        });
      });
    }

    document.querySelectorAll('.dn-range').forEach((card) => {
      card.addEventListener('pointermove', (event) => {
        const rect = card.getBoundingClientRect();
        card.style.setProperty('--dn-cursor-x', `${event.clientX - rect.left}px`);
        card.style.setProperty('--dn-cursor-y', `${event.clientY - rect.top}px`);
      });
    });

    document.querySelectorAll('.dn-header__mobile a').forEach((link) => {
      link.addEventListener('click', () => link.closest('details')?.removeAttribute('open'));
    });

    const menuItems = [...document.querySelectorAll('.dn-header__menu-item')];
    menuItems.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (item.open) menuItems.filter((other) => other !== item).forEach((other) => other.removeAttribute('open'));
      });
      item.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => item.removeAttribute('open')));
    });
    document.addEventListener('pointerdown', (event) => {
      if (!event.target.closest('.dn-header__menu-item')) menuItems.forEach((item) => item.removeAttribute('open'));
    });

    const header = document.querySelector('.dn-header');

    const dnNavLinks = [...document.querySelectorAll('.dn-header__nav [data-dn-nav-target]')];
    const dnNavSections = dnNavLinks.map((link) => document.getElementById(link.dataset.dnNavTarget)).filter(Boolean);
    if (dnNavLinks.length && dnNavSections.length && 'IntersectionObserver' in window) {
      const navObserver = new IntersectionObserver((entries) => {
        const visible = entries.filter((entry) => entry.isIntersecting).sort((a,b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (!visible) return;
        dnNavLinks.forEach((link) => link.classList.toggle('is-active', link.dataset.dnNavTarget === visible.target.id));
      }, { rootMargin: '-20% 0px -62% 0px', threshold: [0, .1, .25, .5] });
      dnNavSections.forEach((section) => navObserver.observe(section));
    }

    const progress = document.querySelector('.dn-scroll-progress span');
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        const scrolled = window.scrollY;
        const available = document.documentElement.scrollHeight - window.innerHeight;
        header?.classList.toggle('is-scrolled', scrolled > 24);
        if (progress) progress.style.transform = `scaleX(${available > 0 ? Math.min(1, scrolled / available) : 0})`;
        ticking = false;
      });
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
  else ready();
})();
